import Web3 from "web3";
import moment from "moment";
import React, { Fragment } from "react";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardBody,
  Col,
  Table,
  Button,
  CardFooter,
  Row,
  CardHeader,
} from "reactstrap";
import Page from "../../components/Page";
import Avatar from "../../components/Avatar";
import MembershipEdit from "./MembershipEdit";
import PageSpinner from "../../components/PageSpinner";
import { NOTIFICATION_SYSTEM_STYLE } from "../../utils/constants";
import { contractAddress } from "./Membership";
import userImage from "../../assets/img/user.jpg";
import membershipABI from "../../contracts_abi/membership.json";

class MembershipDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      membership: props.membership || {},
      membershipPurchasedBy: [],
      showLoader: false,
    };
  }

  componentDidMount() {
    this.getMembershipPurchasedBy();
  }

  getMembershipPurchasedBy = async (type) => {
    try {
      const account = localStorage.getItem('walletAddress');
      const web3 = new Web3(Web3.givenProvider);
      const myContract = await new web3.eth.Contract(membershipABI, contractAddress);
      const membershipPurchasedBy = await myContract.methods
        .getMembershipPurchasedBy(this.state.membership.membershipId)
        .call();
      console.log({ membershipPurchasedBy });
      if (membershipPurchasedBy && membershipPurchasedBy.length) {
        this.setState({
          showLoader: false,
          membershipPurchasedBy: membershipPurchasedBy.map(membership => (
            {
              _id: membership._id,
              expiryDate: membership.expiryDate,
              purchaseBy: membership.purchaseBy,
            }
          ))
        });
      }
    } catch (error) {
      console.log({ error });
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  rendermembershipEditPage = (membership, key) => {
    this.setState({ membership, membershipEditPage: true, editMembership: key });
  };

  closeMembershipEditPage = async (obj) => {
    this.setState({ membershipEditPage: false });
    if (obj.refreshList) {
      this.getMemberships();
    }
  };

  render() {
    return (
      <Fragment>
        {this.state.membershipEditPage ? (
          <MembershipEdit
            history={this.props.history}
            membership={this.state.membership}
            editMembershipKey={this.state.editMembership}
            closeMembershipEditPage={(event) => this.closeMembershipEditPage(event)}
          ></MembershipEdit>
        ) : (
          <div>
            <PageSpinner showLoader={this.state.showLoader} />
            <Page
              title="Membership Detail"
              breadcrumbs={[{ name: "Membership Detail", active: true }]}
            >
              <Col className="pl-0">
                <Card className="mb-3">
                  <CardHeader>
                    <Row className="playerDetailRow">
                      <Col xl={3} lg={3} md={3}>
                        <Avatar
                          style={{ marginRight: "10px" }}
                          className="profileImg"
                          src={userImage}
                        />
                      </Col>
                      <Col xl={9} lg={9} md={9}>
                        <Row
                          style={{
                            marginBottom: "10px",
                            borderBottom: "2px solid #17517b",
                          }}
                        >
                          <Col xl={7} lg={7} md={7}>
                            <h1>
                              {this.state.membership.membershipName}
                            </h1>
                          </Col>
                        </Row>
                        <Row>
                          <Col xl={12} lg={12} md={12}>
                            <Row>
                              <Col xl={4} lg={4} md={4}>
                                <strong>Total Members</strong>
                              </Col>
                              <Col xl={8} lg={8} md={8}>
                                <p>
                                  {this.state.membership.membershipSold
                                    ? this.state.membership.membershipSold
                                    : 0
                                  }
                                </p>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl={4} lg={4} md={4}>
                                <strong>Key Duration</strong>
                              </Col>
                              <Col xl={8} lg={8} md={8}>
                                <p>
                                  {this.state.membership.unlimitedDuration
                                    ? "Unlimited"
                                    : this.state.membership.membershipDuration}
                                </p>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl={4} lg={4} md={4}>
                                <strong>Key Quantity</strong>
                              </Col>
                              <Col xl={8} lg={8} md={8}>
                                <p>
                                  {this.state.membership.unlimitedCount
                                    ? "Unlimited"
                                    : this.state.membership.membershipCount
                                  }
                                </p>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl={4} lg={4} md={4}>
                                <strong>Price</strong>
                              </Col>
                              <Col xl={8} lg={8} md={8}>
                                <p>
                                  {this.state.membership.freeMembership
                                    ? 0
                                    : this.state.membership.membershipPrice
                                  }
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <h2>Members</h2>
                    <Table striped hover responsive>
                      <thead>
                        <tr className="text-center">
                          <th> Token Id</th>
                          <th>Owner</th>
                          <th>Expiry</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.membershipPurchasedBy &&
                          this.state.membershipPurchasedBy.length > 0 ? (
                          this.state.membershipPurchasedBy.map((membership, index) => (
                            <tr key={index}>
                              <td align="center">
                                <div>{membership._id}</div>
                              </td>
                              <td align="center">
                                <div>{membership.purchaseBy}</div>
                              </td>
                              <td align="center">
                                <div>{
                                  membership.expiryDate === 0 || membership.expiryDate === "0"
                                    ? 'Never'
                                    : moment(Number(membership.expiryDate) * 1000).format('LLL')
                                }</div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No members found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </CardBody>
                  <CardFooter>
                    <Button
                      onClick={this.props.toggleMembershipDetailPage}
                    >
                      Back
                    </Button>
                  </CardFooter>
                </Card>
              </Col>
              <NotificationSystem
                dismissible={false}
                ref={(notificationSystem) =>
                  (this.notificationSystem = notificationSystem)
                }
                style={NOTIFICATION_SYSTEM_STYLE}
              />
            </Page>
          </div>
        )}
      </Fragment>
    );
  }
}
export default MembershipDetail;
